import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  getStoreByWarehouseInfo,
  getWarehouseOrderStatusReport,
} from "../../services/warehouse/WarehouseProcess";
import {
  localeDateEndDate,
  localeDateStartDate,
} from "../../constants/DateUtil/DateUtil";
import SchedularModalOrderStatusReport from "../SchedularModalOrderStatusReport";
import { DataTable } from "primereact/datatable";
import { Column } from "jspdf-autotable";
import { Dropdown } from "primereact/dropdown";

const { innerWidth: width, innerHeight: height } = window;

const WarehouseOrderStatusReport = () => {
  const navigate = useNavigate();

  const { warehouseData } = getUserData();

  let warehouseId = warehouseData.id;

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 7); // subtract 7 days to current date

  const [orderStatusReportData, setOrderStatusReportData] = useState([]);

  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [challanSchedularModalVisible, setChallanSchedularModalVisible] =
    useState(false);

  const [storeValue, setStoreValue] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [storeListId, setStoreListId] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setStartDate(newSchedular?.startDate);
    setEndDate(newSchedular?.endDate);
  };

  const initializeVariable = () => {
    setOrderStatusReportData([]);
  };

  const handleCalendarModal = () => {
    setChallanSchedularModalVisible(true);
  };

  const handleStoreChange = (selectedItem) => {
    setStoreValue(selectedItem);
    setSearchTerm("");
  };

  const fetchStoreData = () => {
    getStoreByWarehouseInfo(warehouseId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeData = response.data.map((item) => ({
            name: item.store.storeName,
            value: item.id, // store.id
          }));
          const storeDataId = response.data.map((item) => item.id);

          setStoreList(storeData);
          setStoreListId(storeDataId);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreData();
  }, []);

  const fetchReport = (data) => {
    getWarehouseOrderStatusReport(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderStatusReportData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (storeValue || startDate || endDate) {
      const data = {
        startDate: localeDateStartDate(startDate),
        endDate: localeDateEndDate(endDate),
        wareHouseIds: [warehouseId],
        storeWareHouseIds: storeValue ? [storeValue] : storeListId,
        status: [
          "IN_PROCESS",
          "PROCESSED",
          "UNPROCESSED",
          "READY_TO_SEND_TO_STORE_BY_WARE_HOUSE",
        ],
      };
      fetchReport(data);
    }
  }, [startDate, endDate, storeValue]);

  const filterOrderInfoList = () => {
    return orderStatusReportData.filter((item) => {
      const invoiceNo = item?.invoiceNo?.toLowerCase();
      const matchesSearchTermInvoiceNo = invoiceNo?.includes(
        searchTerm?.toLowerCase(),
      );
      return matchesSearchTermInvoiceNo;
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const wareHouseStatusColor = {
    IN_TIME: "#F4C430",
    OUT_TIME: "#F76AA0",
    DEFAULT: "#3EB3E1",
  };

  const itemTemplate = (order, index) => {
    const orderStatusColor = wareHouseStatusColor.DEFAULT;
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${index + 1}`}
          ></AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`Bill No. - ${order.invoiceNo} | Total Garment - ${order.count}`}
          >
            <div className="cursor-pointer">
              {order?.orderStatusList.map((item) => (
                <div className="flex-row">
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">Status</p>
                    <p className="text-lg font-bold capitalize">
                      {item.status.replace(/_/g, " ")}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Garment Count
                    </p>
                    <p className="text-lg font-bold capitalize">{item.count}</p>
                  </div>
                </div>
              ))}
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div className="cursor-pointer">
        <span>{rowData?.invoiceNo}</span>
      </div>
    );
  };

  // const updatedData = orderStatusReportData.map((order) => {
  //   const processedCount =
  //     order.orderStatusList?.find(
  //       (item) => item.status === "PROCESSED"
  //     )?.count || 0;

  //   const unprocessedCount =
  //     order.orderStatusList?.find(
  //       (item) => item.status === "UNPROCESSED"
  //     )?.count || 0;

  //   return {
  //     ...order,
  //     totalGarmentCount: processedCount + unprocessedCount,
  //   };
  // });

  const filteredData = orderStatusReportData.filter((order) => {
    const totalGarmentCount = order.orderStatusList
      ?.filter(
        (item) => item.status === "PROCESSED" || item.status === "UNPROCESSED",
      )
      .reduce((total, item) => total + (item.count || 0), 0);

    return totalGarmentCount === order.count;
  });

  const RenderTabView = (data) => {
    // Get all unique statuses from all orders
    const statusColumns = [
      ...new Set(
        data?.flatMap((item) =>
          item?.orderStatusList?.map((statusItem) => statusItem.status),
        ),
      ),
    ];

    return (
      <DataTable
        showGridlines
        value={data}
        paginator
        rows={100}
        rowsPerPageOptions={[50, 100]}
        stripedRows
        scrollable
        scrollHeight={height - 280}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) => options.rowIndex + 1}
        />

        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "120px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        />

        <Column field="count" header="Total Garment" />

        {statusColumns.map((status) => (
          <Column
            key={status}
            header={status
              .replace(/_/g, " ")
              .replace("SENT TO WARE HOUSE", "RECEIVED")}
            style={{ minWidth: "180px" }}
            body={(rowData) => {
              const statusData = rowData?.orderStatusList?.find(
                (item) => item.status === status,
              );

              return <span>{statusData?.count ?? 0}</span>;
            }}
          />
        ))}
      </DataTable>
    );
  };

  const exportExcel = () => {
    const statusColumns = [
      ...new Set(
        filteredOrderInfoData?.flatMap(
          (item) =>
            item?.orderStatusList?.map((statusItem) => statusItem.status) || [],
        ),
      ),
    ];

    import("xlsx").then((xlsx) => {
      const exportData = filteredOrderInfoData.map((item) => {
        const statusData = statusColumns.reduce((acc, status) => {
          const statusItem = item?.orderStatusList?.find(
            (item) => item.status === status,
          );

          acc[status] = statusItem?.count ?? 0;

          return acc;
        }, {});

        return {
          "Invoice No": item.invoiceNo,
          "Total Count": item.count,
          ...statusData,
        };
      });

      const worksheet = xlsx.utils.json_to_sheet(exportData);

      const workbook = {
        Sheets: {
          data: worksheet,
        },
        SheetNames: ["data"],
      };

      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Warehouse_Order_Status");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
      }
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Order Status Report
              </p>
            </div>
          </div>

          

          {filteredData.length > 0 && storeValue && (
            <div className="flex justify-content-center align-items-center mr-6">
              <div
                className="active-package-button flex-1 cursor-pointer"
                onClick={() =>
                  navigate("/WarehouseOrderStatusReportDone", {
                    state: {
                      data: filteredData,
                    },
                  })
                }
              >
                <span className="shine" />
                Done Order
              </div>
            </div>
          )}
          {storeValue && (
            <div className="flex justify-content-center align-items-center mr-2">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                />
              </div>
            </div>
          )}
          <i
            className="pi pi-search"
            onClick={() => setSearchTermView(!searchTermView)}
            style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
          ></i>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-4 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
        </div>
      </div>

      <div className="mx-4 my-2">
        {searchTermView && (
          <div className="my-2 mx-1 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={"Search Invoice No."}
                  value={searchTerm}
                  keyboardType={"numeric"}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm && (
              <div
                className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                onClick={handleClearSearch}
              >
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            )}
          </div>
        )}
        <div>
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <div className="w-full ">
              <div className="mx-2 mt-2">
                <Dropdown
                  value={storeValue}
                  onChange={(e) => handleStoreChange(e.value)}
                  options={storeList}
                  placeholder="Select Store"
                  optionLabel="name"
                  className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                />
              </div>
            </div>
          </div>
          {orderStatusReportData.length > 0 ? (
            <>
              <div className="scroll-bar mb-2 mt-4">
                <div className="mx-4 report-table">
                  <div className="tab-view-table">
                    {RenderTabView(
                      filteredOrderInfoData || orderStatusReportData,
                    )}
                  </div>
                </div>
              </div>
              {/* <DataView
                value={filteredOrderInfoData || orderStatusReportData}
                listTemplate={listTemplate}
                paginator
                rows={20}
              /> */}
            </>
          ) : orderStatusReportData.length === 0 ? (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">No Tag Found</p>
            </div>
          ) : (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">Tag List is Loading</p>
            </div>
          )}
        </div>

        <SchedularModalOrderStatusReport
          setSchedularModalVisible={setChallanSchedularModalVisible}
          schedularModalVisible={challanSchedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
          typeOfOrder={""}
        />
      </div>
    </div>
  );
};

export default WarehouseOrderStatusReport;
